import styled from "styled-components";
import { theme } from "../../theme";

export const StyledTable = styled.table`
  width: 100%;
  border-spacing: 0;
  @media (max-width: 768px) {
    font-size: 14px;
  }
  @media (max-width: 488px) {
    width: max-content;
  }
`;

export const StyledTableHead = styled.thead``;

export const StyledTr = styled.tr`
  img {
    width: 55px;
    height: 55px;
  }
  .qr_id_th,
  .qr_id_tr {
    @media (max-width: 768px) {
      display: none;
    }
  }
`;

export const StyledTh = styled.th`
  padding: 10px 16px;
  text-align: left;
  border: 0.1px solid ${theme.textColor.lightGray};
  background-color: ${theme.textColor.secondaryWhite};
  min-width: 130px;
`;

export const StyledTd = styled.td`
  padding: 10px 16px;
  text-align: left;
  border: 0.1px solid ${theme.textColor.lightGray};
  min-width: 130px;
  &:first-child {
    width: 87px !important;
    min-width: 87px !important;
  }
  &.qr-type {
    font-weight: bold;
    text-transform: uppercase;
  }
  svg {
    width: 25px;
    height: 25px;
    margin-right: 15px;
    cursor: pointer;
  }
`;

export const StyledTableBody = styled.tbody``;
